import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import AngleRightSvg from "../../Svg/AngleRightSvg";
import AlertContext from "../../context/AlertContext";

export default function BreadCrumbs() {
  const Alert = useContext(AlertContext);

  const { pathname } = useLocation();

  const gotToDashboard = (path) => {
    sessionStorage.removeItem("modId");

    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    Alert.setLpData({});
    Alert.setTestData({});

    if (!pathname.includes("learningpath") || path === "dashBoard") {
      Alert.setCourseData(null);
      if (localStorage.getItem("mockLp")) {
        Alert.navigate("main/mock/library");
      } 
      else if (path !== "dashBoard" && pathname === "/home") {
        if (
          !Alert?.courseData?.courses[0]?.modules ||
          Alert?.courseData?.courses[0]?.modules.length <= 1
        ) {
          Alert.navigate("/main/dashboard");
        } else {
          Alert.navigate("/main/dashboard/learningpath");
        }
      } 
      else if (path === "dashBoard" && pathname === "/home") {
          Alert.navigate("/main/dashboard");
      }
      else if (Alert?.courseData?.courses[0]?.modules.length > 1) {
        Alert.navigate("/main/dashboard");
      } 
      else if (pathname === "/home") {
        Alert.navigate("/main/dashboard");
      }
    }

    if (localStorage.getItem("mockLp")) {
      localStorage.removeItem("mockLp");
    }
  };
  
  return (
    <div className="breadCrumbMainContainer">
      <div className="breadCrumb" onClick={() => gotToDashboard("dashBoard")}>
        {Alert?.courseData?.batchname ??  localStorage.getItem("batchname")}
      </div>
      {(Alert?.lpData?.lpname?.trim() !== Alert?.lpData?.pmodname?.trim() ||
        Alert?.courseData?.courses?.[0]?.modules?.length > 1) && (
        <>
          <AngleRightSvg component="codingPageLearnerSideBreadCrumbs" />
          <div
            onClick={() => gotToDashboard("learningpath")}
            className={`breadCrumb ${
              pathname.includes("learningpath") ? "activate" : ""
            }`}
          >
            {Alert?.courseData?.courses[0]?.lpname || Alert?.lpData?.lpname}
          </div>
        </>
      )}
      {pathname === "/home" && (
        <>
          <AngleRightSvg component="codingPageLearnerSideBreadCrumbs" />
          <div
            className={`breadCrumb ${pathname === "/home" ? "activate" : ""}`}
          >
            {Alert?.lpData?.pmodname}
          </div>
        </>
      )}
    </div>
  );
}
